<template>
  <v-card flat height="100%">
    <v-card-title>
      Campaign {{ campaign.name }}
      <template v-if="campaign.id">
        <v-spacer></v-spacer>
        <v-btn color="primary" :to="{ name: 'edit_email_campaign_path', params: { id: campaign.id }}">Edit Campaign</v-btn>
      </template>
      <v-tabs v-model="tabIndex" grow>
        <v-tab>Campaign Stats</v-tab>
        <v-tab>Email Response</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-tabs-items v-model="tabIndex">
        <!-- Campaign Stats -->
        <v-tab-item>
          <campaign-lifetime-stats
            chart-prefix="lifetime"
            :dealer="dealer"
            :campaign="campaign"
          />
          <!-- NOTE using key on the campaign-activity-stats to prevent caching
              and force a reload on the chart
          -->
          <daily-email-activity
            chartPrefix="'dea-' + campaign.id"
            :dealer="dealer"
            :campaign="campaign"
            :byCampaign="true"
          />
          <campaign-activity-stats
            :key="'cas-' + campaign.id"
            chartPrefix="campaign"
            :dealer="dealer"
            :campaign="campaign"
          />
        </v-tab-item>

        <!-- Conversion Stats -->
        <v-tab-item>
          <conversion-stats-card :campaign-id="campaign.id" :campaign-name="campaign.name" />
        </v-tab-item>

      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { CampaignActivityStats, CampaignLifetimeStats, DailyEmailActivity } from '@/components/charts'
import ConversionStatsCard from '../conversionStats/ConversionStatsCard'

export default {
  props: {
    emailCampaignId: {
      type: [Number, String],
      required: false,
      default: null
    }
  },
  data () {
    return {
      tabIndex: 0
    }
  },
  components: {
    [DailyEmailActivity.name]: DailyEmailActivity,
    [CampaignActivityStats.name]: CampaignActivityStats,
    [CampaignLifetimeStats.name]: CampaignLifetimeStats,
    [ConversionStatsCard.name]: ConversionStatsCard
  },
  computed: {
    ...mapState('DealerStore', { dealer: 'dealer' }),
    ...mapState('EmailCampaignStore', { campaign: 'emailCampaign' })
  },
  watch: {
    dealer () {
      // redirect to index because the campaign does not belong to the dealer....
      this.$router.push({ name: 'email_campaigns_path' })
    }
  },
  methods: {
    loadCampaign () {
      let campaignId = null
      if (this.$route.params.id) {
        campaignId = this.$route.params.id
      } else {
        campaignId = this.emailCampaignId
      }
      this.$store
        .dispatch('EmailCampaignStore/getEmailCampaign', {
          id: campaignId
        })
        .then(emailCampaign => {
          this.$logger.trace('Email Campaign Loaded!')
        })
        .catch(error => {
          this.$logger.error('Error loading EmailCampaign', error.message)
          this.$flash({
            showClose: true,
            message: 'Error Loading. Reload to try again',
            type: 'error',
            duration: 0
          })
        })
    }
  },
  created () {
    this.loadCampaign()
  }
}
</script>
